import { requestAllCode } from "@/apis/code_api";

const state = {
  resultAllCodeList: [],

  requestAllFlag: false
};

const getters = {
  getAllCodeList(state) {
    return state.resultAllCodeList;
  },

  getRequestAllFlag(state) {
    return state.requestAllFlag;
  }
};

const mutations = {
  CODE_ALL_LIST(state, data) {
    state.resultAllCodeList = data.resultAllCodeList;
  },

  REQUEST_ALL_FINISH(state) {
    state.requestAllFlag = true;
  }
};

const actions = {
  async REQUEST_ALL_CODE_LIST({ commit }) {
    try {
      const res = await requestAllCode();

      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("CODE_ALL_LIST", data);
      commit("REQUEST_ALL_FINISH");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  }
};

export default { mutations, state, actions, getters };
